import { FormattedMessage } from 'react-intl';
import styles from '../styles.module.scss';
import React from 'react';
import { useQuery } from '@apollo/client';
import { queries } from '../../../api';
import { Button } from 'react-bootstrap';
import parse from 'html-react-parser';
import sanitizeHtml from 'sanitize-html';
import LoadingSpinner from '../../../components/loading-spinner';
import PropdocsModal from '../../../components/modal/PropdocsModal';
import { TitleFormattedMessage } from '../../../components/titleFormattedMessage';

interface TermsOfUseModalProps {
  showTermsOfUseModal: boolean;
  onModalHide: () => void;
  organizationId: string;
}
const TermsOfUseModal = ({ showTermsOfUseModal, onModalHide, organizationId }: TermsOfUseModalProps) => {
  const { data: organizationsData, loading: isOrganizationsDataLoading } = useQuery(queries.getOrganizations);

  const currentOrg = organizationsData?.organizations.find((org) => {
    return org.id === organizationId;
  });

  if (isOrganizationsDataLoading) {
    return <LoadingSpinner />;
  }

  return (
    <PropdocsModal
      show={showTermsOfUseModal}
      setShow={onModalHide}
      size="lg"
      title={
        <header>
          <FormattedMessage id="title.terms-of-use" defaultMessage="Terms of Use" />
        </header>
      }
    >
      <div className={styles.termsOfUseModalContent}>
        <div className="w-100">
          <div className={styles.termOfUseOrgParsed}>
            {parse(sanitizeHtml(currentOrg?.termsOfUse?.content as string))}
          </div>
        </div>
        <div className="flex-end">
          <Button variant="primary" className="pl-3 pr-3" onClick={onModalHide}>
            <TitleFormattedMessage id="cta.close" defaultMessage="Close" />
          </Button>
        </div>
      </div>
    </PropdocsModal>
  );
};

export default TermsOfUseModal;
